/**
 * Register all Routes here for easy future modification.
 * Paths must start with '/'
 */
enum Routes {
  LANDING = '/',
  SIGN_UP = '/signup',
  SIGN_IN = '/signin',
  DEVELOPERS = '/developers',
  PROFILE = '/profile',
  EDIT_PROFILE = '/edit-profile',
  DASHBOARD = '/dashboard',
  ADD_EXPERIENCE = '/add-experience',
  ADD_EDUCATION = '/add-education',
  POST = '/post',
  POSTS = '/posts',
}

export default Routes;
